
import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'

import './label.css'
export function Label({ className = '', ...props }) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={`label ${className}`}
      {...props}
    />
  )
}
